import React from "react";
const deactivateSettings=()=>{
  if(document.getElementById('shirtSettings')){
   document.getElementById('shirtSettings').id='shirtSettingsShrink';
  }
 }
const NewArrivals = ({ props }) => {
  console.error(props);
  return (

    <div className="row products_row">

      {props.newArrivals.map((product, i) => (
    <div key={i} className="col-sm-6 col-lg-4 col-xl-4 ">

          <div className="product">
            <div  className="product_image">
              <img id='productImage' style={{border:'2px solid lightgray'}}  src={product.img} alt="" />
            </div>
            <div id='burst-12'>
              <span>New Arrival</span>
               
            </div>
            <div id='productContent' className="product_content col-12 col-xl-4 col-md-6">
              <div className="product_info d-flex flex-row align-items-start justify-content-start">
                <div>
                  <div>
                    <div className="product_name">
                      <a >
                        {product.describtion}
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div></div>
                </div>
                <div className="ml-auto text-right">
                  <div className="rating_r rating_r_4 home_item_rating">
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                  </div>
                  <div className="product_price text-right">
                    {product.price}
                    <span>EGP</span>
                  </div>

                </div>

                
              </div>
              <div className="product_buttons">
            <div className="text-right d-flex flex-row align-items-start justify-content-start">
                {/* <div class="product_button product_fav text-center d-flex flex-column align-items-center justify-content-center">
                    <div><div><img src="/Assets/images/heart_2.svg" class="svg" alt=""/><div>+</div></div></div>
                </div> */}
                <div onClick={(e)=>{e.stopPropagation();props.onSelectedColorChange(product.color);props.onSelectedShirtTypeChange({type:product.type,price:product.price});document.getElementById('designerContainer').scrollIntoView({ behavior: 'smooth', block: 'center' });deactivateSettings();}} className="product_button product_cart text-center d-flex flex-column align-items-center justify-content-center">
                    <div><div><img  src="/Assets/images/cart.svg" className="svg" alt=""/><div>+</div></div></div>
                </div>
            </div>
        </div>

            </div>
          </div>
      </div>
      ))}
    </div>
  );
};

export default NewArrivals;
